import toast from "react-hot-toast";
import { formatDateDb } from "../../utils/tools";

const { clientAPI } = require("../client");
export const totalCommissionCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/totalCommission", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  createPaymentPeriod: async (data) => {
    try {
      const response = await clientAPI("post", "/TotalCommission/paymentPeriod", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/totalCommission/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updatePaymentPeriod: async (id, data) => {
    try {
      const response = await clientAPI("put", `/TotalCommission/paymentPeriod/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateHiddenStatus: async (id) => {
    try {
      const response = await clientAPI("put", `/totalCommission/updateHiddenStatus/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approvePaymentPeriod: async (id) => {
    try {
      const response = await clientAPI("put", `/TotalCommission/paymentPeriod/approve/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await clientAPI("delete", `/totalCommission/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  deletePaymentPeriod: async (id) => {
    try {
      const response = await clientAPI("delete", `/TotalCommission/paymentPeriod/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getTotalPrice: async (lockingId) => {
    try {
      const response = await clientAPI("get", `/totalCommission/getTotalPrice?lockingId=${lockingId}`);

      return response;
    } catch (error) {
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getPaymentPeriodList: async (lockingId, period, page = 1, limit = 9999) => {
    try {
      const options = {
        lockingId, period, page, limit
      }
      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/TotalCommission/paymentPeriod?${queryParams}`);

      return response;
    } catch (error) {
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getPaymentServiceFeeList: async (lockingId, period, page = 1, limit = 9999, periodPayment) => {
    try {
      const options = {
        lockingId, period, page, limit
      }
      if (periodPayment) {
        options.periodPayment = periodPayment
      }
      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/TotalCommission/paymentPeriod/paymentServiceFee?${queryParams}`);

      return response;
    } catch (error) {
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getTotalCommissionByLockingIdAndPeriod: async (lockingId = "", period = 1) => {
    try {
      const response = await clientAPI(
        "get",
        `/TotalCommission/locking/period/${lockingId}/${period}`
      );
      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  importTotalCommission: async (input, name) => {
    try {
      const data = {
        input,
        name,
      };
      const response = await clientAPI(
        "post",
        "/totalCommission/importTotalCommission/",
        data
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  importTotalCommissionCheck: async (input, name) => {
    try {
      const data = {
        input,
        name,
      };
      const response = await clientAPI(
        "post",
        "/totalCommission/importTotalCommissionCheck/",
        data
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  deletePaymentPeriodByImport: async (input, name) => {
    try {
      const data = { input, name };
      const response = await clientAPI(
        "post",
        "/totalCommission/deletePaymentPeriodByImport/",
        data
      );
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  deletePaymentPeriodByImportCheck: async (input, name) => {
    try {
      const data = { input, name };
      const response = await clientAPI(
        "post",
        "/totalCommission/deletePaymentPeriodByImportCheck/",
        data
      );
      return response;
    } catch (error) {
      console.error("Delete check error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  exportTotalCommission: async (param) => {
    try {
      const options = {};

      if (param.search !== undefined) options.search = param.search;
      if (param.projectId?.length) options.projectId = param.projectId;
      if (param.status?.length) options.status = param.status;
      if (param.apartmentId?.length) options.apartmentId = param.apartmentId;
      if (param.month) options.month = param.month;
      if (param.year) options.year = param.year;

      const queryParams = new URLSearchParams(options).toString();

      const response = await clientAPI(
        "get",
        `/totalCommission/exportTotalCommission?${queryParams}`
      );

      const dataExport = response?.exportData;

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};